import { Collection } from 'modules/core/lib/mobx-rest'
import { EventTypes, dispatch } from 'modules/core/lib/pubSub'

import Shift from 'modules/attendance/store/models/Shift'

class Shifts extends Collection<Shift> {
  get cacheKey(): string {
    return 'attendanceShifts'
  }

  model() {
    return Shift
  }

  get indexes() {
    return ['day', 'date', 'period_id', 'workable', 'automatic_clock_in', 'reference_date']
  }

  async toggle(action: string, data: Record<string, any>) {
    const result = await this.rpc(action, data)

    dispatch({
      type: EventTypes.ATTENDANCE_SHIFT_TOGGLED,
      data: { action },
    })

    return result
  }
}

const singleton: Shifts = new Shifts()

export default singleton
